export const BuildInfo = {timestamp:1788969354000}
